/** Escape a CSV field per RFC 4180 — wrap in quotes if it contains a comma, quote, or newline,
 *  and double up any inner quotes. Null/undefined become empty strings; non-strings are coerced
 *  via String(). Use at any call site that builds CSV by hand. */
export const csvEscape = (raw: unknown): string => {
	if (raw === null || raw === undefined) return "";
	const s = String(raw);
	return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};
